// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkNotificationsReadBatchRequest
 */
export interface MarkNotificationsReadBatchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkNotificationsReadBatchRequest
     */
    notification_ids: Array<string>;
}

/**
 * Check if a given object implements the MarkNotificationsReadBatchRequest interface.
 */
export function instanceOfMarkNotificationsReadBatchRequest(value: object): value is MarkNotificationsReadBatchRequest {
    if (!('notification_ids' in value) || value['notification_ids'] === undefined) return false;
    return true;
}

export function MarkNotificationsReadBatchRequestFromJSON(json: any): MarkNotificationsReadBatchRequest {
    return MarkNotificationsReadBatchRequestFromJSONTyped(json, false);
}

export function MarkNotificationsReadBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkNotificationsReadBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'notification_ids': json['notification_ids'],
    };
}

export function MarkNotificationsReadBatchRequestToJSON(json: any): MarkNotificationsReadBatchRequest {
    return MarkNotificationsReadBatchRequestToJSONTyped(json, false);
}

export function MarkNotificationsReadBatchRequestToJSONTyped(value?: MarkNotificationsReadBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification_ids': value['notification_ids'],
    };
}
